import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  min-height: 75px;
  margin-top: 60px;
  margin-bottom: 40px;
  position: relative;
`;

export const PoweredByLabel = styled.span`
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: #000000;
`;
